let DeviceUtil = {};

DeviceUtil.REGION_LOCATIONS = [
  "FOREHEAD",
  "ANTERIOR_NECK",
  "MEDIAL_CHEST",
  "HYPOCHONDRIUM",
  "EPIGASTRIUM",
  "ANTERIOR_FOREARM", // Proximal
  "DISTAL_ANTERIOR_FOREARM",
  "POSTERIOR_FOREARM",
  "ANTERIOR_THIGH",
  "LATERAL_THIGH",
  "POSTERIOR_THIGH",
  "PROXIMAL_LATERAL_SHANK",
  "DISTAL_LATERAL_SHANK",
  "LUMBAR",
  "SACRUM",
  "DORSAL_HAND",
  "DORSAL_FOOT"
];

DeviceUtil.MUSCLE_LOCATIONS = [
  "PECTORALIS",
  "MEDIAL_DELTOID",
  "TRAPEZIUS",
  "RHOMBOIDEUS",
  "LATISSIMUS_DORSI",
  "BICEP",
  "TRICEP",
  "FLEXOR_DIGITORUM",
  "EXTENSOR_DIGITORUM",
  "BRACHIORADIALIS",
  "EXTENSOR_CARPI_RADIALIS_LONGUS",
  "RECTUS_FEMORIS",
  "BICEPS_FEMORIS",
  "TIBIALIS_ANTERIOR",
  "GASTROCNEMIUS",
  "RECTUS_ABDOMINIS",
  "ABDOMINAL_OBLIQUE",
  "GLUTEUS_MAXIMUS"
];

DeviceUtil.SPINE_LOCATIONS = [
  "CERVICAL_SPINE",
  "UPPER_THORACIC_SPINE",
  "MID_THORACIC_SPINE",
  "LUMBAR_SPINE"
];

DeviceUtil.CARDIO_LOCATIONS = [
  "ECG_LEAD_I",
  "ECG_LEAD_II",
  "ECG_LEAD_III"
];

DeviceUtil.SINGULAR_LOCATIONS = [
  "MEDIAL_CHEST",
  "SACRUM",
  "ECG_LEAD_I",
  "ECG_LEAD_II",
  "ECG_LEAD_III",
  "CERVICAL_SPINE",
  "UPPER_THORACIC_SPINE",
  "MID_THORACIC_SPINE",
  "LUMBAR_SPINE",
  "FOREHEAD",
  "ANTERIOR_NECK",
  "EPIGASTRIUM"
];

DeviceUtil.DEFAULT_RIGHT_ORIENTATIONS = [
  "HYPOCHONDRIUM",
  "ANTERIOR_FOREARM",
  "DISTAL_ANTERIOR_FOREARM",
  "ANTERIOR_THIGH",
  "DORSAL_FOOT",
  "POSTERIOR_FOREARM",
  "POSTERIOR_THIGH",
  "BICEP",
  "RECTUS_ABDOMINIS",
  "GLUTEUS_MAXIMUS"
];

DeviceUtil.SIDES = [
  "ANY",
  "DOMINANT",
  "NON_DOMINANT",
  "DISEASED",
  "NON_DISEASED",
  "RIGHT",
  "LEFT"
];

DeviceUtil.MODES = {
  "ACCEL": {
    signal: null,
    opts: {
      gyro: {
        periodMs: [64, 32, 16, 8, 4],
        accelRange: [2, 4, 8, 16]
      }
    },
    defaultSensorConfig: {
      sensingType: "MPU",
      gyro: {
        mode: "ACCEL",
        periodMs: 32,
        accelRange: 4,
        accelLowPower: true
      }
    },
    runtime: function (sc) {
      return [145, 93, 46, 23, 11][[64, 32, 16, 8, 4].indexOf(sc.gyro.periodMs)];
    },
    format: function (sc) {
      return [
        DeviceUtil.formatValue("periodMs", sc.gyro.periodMs),
        DeviceUtil.formatValue("accelRange", sc.gyro.accelRange)
      ].join(" ");
    }
  },

  "GYRO_ACCEL": {
    signal: null,
    opts: {
      gyro: {
        periodMs: [64, 32, 16, 8, 4],
        gyroRange: [250, 500, 1000, 2000],
        accelRange: [2, 4, 8, 16]
      }
    },
    defaultSensorConfig: {
      sensingType: "MPU",
      gyro: {
        mode: "ACCEL_GYRO",
        periodMs: 16,
        accelRange: 4,
        gyroRange: 2000,
        accelLowPower: false
      }
    },
    runtime: function (sc) {
      return [14, 13, 13, 11, 5][[64, 32, 16, 8, 4].indexOf(sc.gyro.periodMs)];
    },
    format: function (sc) {
      return [
        DeviceUtil.formatValue("periodMs", sc.gyro.periodMs),
        DeviceUtil.formatValue("gyroRange", sc.gyro.gyroRange),
        DeviceUtil.formatValue("accelRange", sc.gyro.accelRange)
      ].join(" ");
    }
  },

  "EMG": {
    signal: "EMG",
    opts: {
      afe: {
        rate: [125, 250, 500, 1000]
      }
    },
    defaultSensorConfig: {
      sensingType: "ANALOG",
      afe: {
        rate: 250,
        gain: 12
      }
    },
    runtime: function (sc) {
      return [70, 35, 17, 8][[125, 250, 500, 1000].indexOf(sc.afe.rate)];
    },
    format: function (sc) {
      return DeviceUtil.formatValue("rate", sc.afe.rate);
    }
  },

  "ACCEL_EMG": {
    signal: "EMG",
    opts: {
      afe: {
        rate: [125, 250, 500, 1000]
      },
      gyro: {
        periodMs: [32],
        accelRange: [2, 4, 8, 16]
      }
    },
    defaultSensorConfig: {
      sensingType: "MPU_ANALOG",
      afe: {
        rate: 250,
        gain: 12
      },
      gyro: {
        mode: "ACCEL",
        periodMs: 32,
        accelRange: 4,
        accelLowPower: true
      }
    },
    runtime: function (sc) {
      return [40, 25, 14, 8][[125, 250, 500, 1000].indexOf(sc.afe.rate)];
    },
    format: function (sc) {
      return [
        DeviceUtil.formatValue("rate", sc.afe.rate),
        DeviceUtil.formatValue("periodMs", sc.gyro.periodMs),
        DeviceUtil.formatValue("accelRange", sc.gyro.accelRange)
      ].join(" ");
    }
  }
};

DeviceUtil.getMode = function (config) {
  let sensorConfig = config.sensorConfig;

  switch (sensorConfig.sensingType) {
    case "ANALOG":
      return "EMG";
    case "MPU_ANALOG":
      return "ACCEL_EMG";
    case "MPU":
      return sensorConfig.gyro.mode === "ACCEL" ? "ACCEL" : "GYRO_ACCEL";
  }
};

DeviceUtil.getRuntimeHours = function (config) {
  let mode = this.getMode(config);
  return this.MODES[mode].runtime(config.sensorConfig);
};

DeviceUtil.isValidLocation = function (loc, mode) {
  return !(mode.match(/EMG/) && !this.MUSCLE_LOCATIONS.concat(this.CARDIO_LOCATIONS).concat(this.SPINE_LOCATIONS).includes(loc));
};

DeviceUtil.formatConfig = function (config) {
  let mode = this.getMode(config);
  return this.MODES[mode].format(config.sensorConfig);
};

DeviceUtil.formatValue = function (type, value) {
  let str = {
    "rate":       value + "Hz",
    "periodMs":   (1000 / value) + "Hz",
    "gyroRange":  "+/-" + value + "˚/s",
    "range":      "+/-" + value + "G",
    "accelRange": "+/-" + value + "G"
  };

  return str[type];
};

module.exports = DeviceUtil;
